export const PRESENCE_TAB_STORAGE_KEY = 'gp-presence-tab'

export function getPresenceTabId() {
  const fallback = () =>
    typeof crypto !== 'undefined' && crypto.randomUUID
      ? crypto.randomUUID()
      : `${Date.now()}-${Math.random().toString(16).slice(2)}`

  try {
    if (typeof sessionStorage === 'undefined') {
      return fallback()
    }

    let tabId = sessionStorage.getItem(PRESENCE_TAB_STORAGE_KEY)
    if (!tabId) {
      tabId = fallback()
      sessionStorage.setItem(PRESENCE_TAB_STORAGE_KEY, tabId)
    }

    return tabId
  } catch {
    return fallback()
  }
}
